import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { MdVisibility, MdVisibilityOff } from "react-icons/md";
import MobileUsersServices from "../../../services/MobileUsersServices";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Full name is required"),
  mobile: Yup.string()
    .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits")
    .required("Mobile number is required"),
  username: Yup.string()
    .min(3, "User name must be at least 3 characters long")
    .required("User name is required"),
  password: Yup.string()
    .min(3, "Password must be at least 3 characters long")
    .required("Password is required"),
});

const AddMobileUserModal = ({ modalIsOpen, setIsOpen, getAllMobileUserData }) => {
  const mobileApi = new MobileUsersServices();
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const initialValues = {
    name: "",
    mobile: "",
    username: "",
    password: "",
  };

  const closeModal = () => setIsOpen(false);

  return (
    <Modal show={modalIsOpen} onHide={closeModal} backdrop="static" className="custom-modal">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          const payload = {
            username: values?.username,
            password: values?.password,
            name: values?.name,
            mobile: values?.mobile,
          };

          mobileApi
            .addMobileUserData(payload)
            .then((response) => {
              if (response.isSuccess) {
                toast.success(response.message);
                closeModal();
                getAllMobileUserData();
              } else {
                toast.error(response.message);
              }
            })
            .catch((error) => {
              console.error("Error addMobileUserData:", error);
              toast.dismiss();
              toast.error("Error add mobile user.");
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
            });
        }}
      >
        {({ errors, touched, isSubmitting, setFieldValue }) => (
          <Form className="addAdmin-form">
            <div className={"modal-header pb-0 pt-2"}>
              <h5 className="modal-title">Add Mobile User</h5>
              <button type="button" className={"btn"} onClick={closeModal}>
                <RiCloseLargeFill />
              </button>
            </div>

            <Modal.Body className="modal-body-scroll">
              <div className="form-group mb-2">
                <label htmlFor="name" className="form-label mb-0">
                  Full Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter full name"
                    className={`form-input ${errors.name && touched.name ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="name">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label htmlFor="mobile" className="form-label mb-0">
                  Mobile Number <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    id="mobile"
                    name="mobile"
                    placeholder="Enter mobile number"
                    className={`form-input ${errors.mobile && touched.mobile ? "input-error" : ""}`}
                    onChange={(e) => {
                      const value = e.target.value;
                      const sanitizedValue = value.replace(/[^0-9]/g, "");
                      setFieldValue("mobile", sanitizedValue);
                      e.preventDefault();
                    }}
                  />
                </div>
                <ErrorMessage name="mobile">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label htmlFor="username" className="form-label mb-0">
                  User Name <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type="text"
                    id="username"
                    name="username"
                    placeholder="Enter user name"
                    className={`form-input ${errors.username && touched.username ? "input-error" : ""}`}
                  />
                </div>
                <ErrorMessage name="username">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="form-group mb-2">
                <label htmlFor="password" className="form-label mb-0">
                  Password <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Field
                    type={showPassword ? "text" : "password"}
                    id="password"
                    name="password"
                    placeholder="Enter password"
                    className={`form-input ${errors.password && touched.password ? "input-error" : ""}`}
                  />
                  <button
                    type="button"
                    className="toggle-password"
                    onClick={() => setShowPassword(!showPassword)}
                    tabIndex="-1"
                    title={showPassword ? "Hide password" : "Show password"}
                  >
                    {showPassword ? <MdVisibilityOff /> : <MdVisibility />}
                  </button>
                </div>
                <ErrorMessage name="password">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>

              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Save Now"
                  )}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default AddMobileUserModal;

